import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const PCMC = ["Wakad", "Hinjawadi", "Pimple Saudagar", "Ravet", "Chinchwad", "Nigdi", "Akurdi", "Bhosari"];
const PUNE = ["Baner", "Koregaon Park", "Viman Nagar", "Kalyani Nagar", "Aundh", "Kothrud", "Hadapsar", "Kharadi"];
const CATS = ["Luxury Spa", "Ayurvedic Spa", "Thai Spa", "Couples Spa", "Wellness Spa", "Foot Spa"];

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E7DDCF] bg-[#F5EFE6] mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo-link">
              <picture>
                <source srcSet="/logo-footer.webp" type="image/webp" />
                <img
                  src="/logo-footer.png"
                  alt="Pune Spa Guide — Relax • Refresh • Renew"
                  className="h-16 w-auto object-contain"
                  width="610"
                  height="256"
                  loading="lazy"
                />
              </picture>
              <span className="sr-only">Pune Spa Guide</span>
            </Link>
            <p className="text-sm text-[#4B5563] leading-relaxed">
              Discover Pune&apos;s finest spa experiences. Verified listings, curated reviews, and direct contact.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-3 text-[#111827]">Spas in PCMC</h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              {PCMC.map((l) => (
                <li key={l}><Link to={`/spas-in-${l.toLowerCase().replace(/\s/g, '-')}`} className="hover:text-[#1F4E3D]">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-3 text-[#111827]">Spas in Pune</h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              {PUNE.map((l) => (
                <li key={l}><Link to={`/spas-in-${l.toLowerCase().replace(/\s/g, '-')}`} className="hover:text-[#1F4E3D]">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-3 text-[#111827]">Categories</h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              {CATS.map((c) => (
                <li key={c}><Link to={`/spas-by-category/${encodeURIComponent(c)}`} className="hover:text-[#1F4E3D]">{c}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-3 text-[#111827]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              <li><Link to="/plans" className="hover:text-[#1F4E3D]">Pricing</Link></li>
              <li><Link to="/blog" className="hover:text-[#1F4E3D]" data-testid="footer-blog-link">Blog</Link></li>
              <li><Link to="/about" className="hover:text-[#1F4E3D]">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-[#1F4E3D]">Contact</Link></li>
              <li><Link to="/register" className="hover:text-[#1F4E3D]">List Your Spa</Link></li>
              <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#1F4E3D]">Owner Terms</Link></li>
              <li><Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#1F4E3D]">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#E7DDCF] flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-[#4B5563]">
          <div>© {new Date().getFullYear()} Pune Spa Guide. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1"><MapPin size={12}/> Pune, Maharashtra</span>
            <a href="mailto:hello@punespaguide.com" className="flex items-center gap-1 hover:text-[#1F4E3D] hover:underline" data-testid="footer-email-link"><Mail size={12}/> hello@punespaguide.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
